import React from 'react';
import { ReactComponent as PrimaryMark } from '../../assets/brand/logo/primary/melio-primary-mono.svg';
import { ReactComponent as SecondaryMark } from '../../assets/brand/logo/secondary/melio-secondary-mono.svg';

const ASPECT = { primary: 500 / 106, secondary: 251 / 45 } as const;

interface WordmarkProps {
  /** Primary = the serif MELIO (key brand moments, the site nav). Secondary = the sans. */
  variant?: 'primary' | 'secondary';
  /** Rendered height in px. The guidelines' minimum is 15pt ≈ 20px. */
  height?: number;
  title?: string;
  className?: string;
}

/**
 * The studio wordmark as an inline SVG filled with `currentColor`, so the nav
 * can turn it white over photography and black over Bone with a single CSS
 * colour. The *-mono.svg files are derived from the studio originals in
 * src/assets/brand/logo with only the fill literal changed.
 */
export default function Wordmark({ variant = 'primary', height = 22, title = 'Melio', className }: WordmarkProps) {
  const Mark = variant === 'primary' ? PrimaryMark : SecondaryMark;
  const h = Math.max(20, height);
  return (
    <Mark
      className={className}
      height={h}
      width={Math.round(h * ASPECT[variant])}
      role="img"
      aria-label={title}
      focusable="false"
    />
  );
}
